var React = require('react');

function ArrowR (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.8,21.05a2.79,2.79,0,0,1,2-.8H35.61L23.8,8.45a2.75,2.75,0,0,1,0-3.9,2.79,2.79,0,0,1,1.95-.8,2.75,2.75,0,0,1,1.94.8l16.5,16.5a2.73,2.73,0,0,1,.6.9,2.73,2.73,0,0,1,0,2.1,2.73,2.73,0,0,1-.6.9l-16.5,16.5a2.77,2.77,0,0,1-1.94.8A2.78,2.78,0,0,1,24.69,42a2.94,2.94,0,0,1-.89-.59,2.73,2.73,0,0,1-.6-.9,2.7,2.7,0,0,1-.21-1,2.73,2.73,0,0,1,.81-2l11.81-11.8H3.75A2.75,2.75,0,0,1,1,23,2.79,2.79,0,0,1,1.8,21.05Z","transform":"translate(-1 -3.75)"}));
}

ArrowR.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 44 38.51"};

module.exports = ArrowR;

ArrowR.default = ArrowR;
